import { BATCH_DEVALUE, BATCH_DEVALUE_ERROR_MESSAGE } from '../action/batchDevalue'

const initialState = {
  errorMsg : '',
  batchUploadResult : false
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch(type) {
    case BATCH_DEVALUE_ERROR_MESSAGE:
      return {
        ...state,
        errorMsg: payload.resultText || 'An error occurred'
      }
    case `${BATCH_DEVALUE}_FULFILLED`:
      if (payload.resultCode === "0") {

        return {
          ...state,
          batchUploadResult: payload.resultText
        }
      } else {
        return {
          ...state,
          errorMsg: payload.resultText
        }
      }
    case `${BATCH_DEVALUE}_PENDING`:
      return {
        ...state,
        errorMsg: ''
      }
    case `${BATCH_DEVALUE}_REJECTED`:
      return {
        ...state,
        errorMsg: 'Cannot connect to server'
      }
    case `${BATCH_DEVALUE}_RESET`:
      return {
        ...initialState
      }

    default:
      return state
  }
}
